import React from 'react';
import { Title, StyledText, ButtonContainer, SmallText } from './SelectInfo.styles';
import Button from '../../utils/Button/Button';
import { useNavigate } from 'react-router-dom';
import FormContainer from '../../utils/FormContainer/FormContainer';
import { useDispatch, useSelector } from 'react-redux';
import {
  resetGuestData,
  selectGuestFlow,
  selectInvitationGuestMembers,
  setGuestFlowCurrentGuestId,
} from '../../../store/slice/rsvp/slice';

const EnterFullName = ({ rsvpKey }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { data } = useSelector(selectInvitationGuestMembers);
  const guestFlow = useSelector(selectGuestFlow);

  const handleContinue = () => {
    dispatch(setGuestFlowCurrentGuestId(data[guestFlow.finished].id));
    if (data.length === 1) {
      const query = { key: rsvpKey, step: 'ATTENDING' };
      const queryString = new URLSearchParams(query).toString();
      const url = `/wedding-guest?${queryString}`;

      navigate(url);
    } else if (data.length > 1) {
      const query = { key: rsvpKey, step: 'MULTIPLEGUEST' };
      const queryString = new URLSearchParams(query).toString();
      const url = `/wedding-guest?${queryString}`;

      navigate(url);
    }
  };

  const goBack = () => {
    dispatch(resetGuestData());
    const query = { key: rsvpKey };
    const queryString = new URLSearchParams(query).toString();
    const url = `/wedding-guest?${queryString}`;

    navigate(url);
  };

  return (
    <FormContainer widthMessage={'Continue if this is your info below or try searching again'} gap>
      <Title>{data.length ? data[0].firstName + ' ' + data[0].lastName : 'Name not found'}</Title>
      <ButtonContainer>
        <Button title={'Continue'} onClick={handleContinue} width />
        <StyledText onClick={() => goBack()}>Try Again</StyledText>
      </ButtonContainer>
      <SmallText>
        If none of these are you, please reach out to the couple to see exactly how they entered your details.
      </SmallText>
    </FormContainer>
  );
};

export default EnterFullName;
